/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import useStyles from './styles';
import { FixedSizeList } from 'react-window';
import { CustomListProps, IVirtualScrollConfig, IVirtualScrollProps } from '../../models/CustomList/CustomList';
import { Checkbox } from '@mui/material';

const virtualScrollConfig: IVirtualScrollConfig = {
  height: 900,
  width: '100%',
  rowHeight: 64
};

export const CustomList: React.FC<CustomListProps> = ({
  data,
  selectedItem,
  onClick,
  handleListItemCheck,
  withCheckbox,
  centeredItem,
  addDivider,
  disableGutters,
  renderItem
}: CustomListProps) => {
  const { classes } = useStyles();

  const renderListRow = (virtalScrollProps: IVirtualScrollProps) => {
    const { index, style } = virtalScrollProps;

    let listItem = data[index];
    return (
      <Box style={{ ...style }} className={classes.border}>
        <Box className={`${classes.sectionCheckBox} ${selectedItem.id === listItem.id ? 'Mui-selected' : ''}`}>
          {withCheckbox && (
            <Checkbox
              onChange={(event: any) => (handleListItemCheck ? handleListItemCheck(event, listItem) : null)}
              {...(listItem.type === 'global'
                ? { disabled: true }
                : { checked: listItem.isChecked ? listItem.isChecked : false })}
              color="primary"
              data-testid="role-checkBox"
              name="role-checkBox"
              classes={{ root: classes.checkboxRole }}
            />
          )}
          <ListItem
            button
            key={index}
            selected={selectedItem.id === listItem.id}
            onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => onClick(event, listItem)}
            alignItems={!centeredItem ? 'flex-start' : 'center'}
            divider={addDivider}
            disableGutters={disableGutters}
          >
            {renderItem(listItem, index)}
          </ListItem>
        </Box>
      </Box>
    );
  };

  return (
    <Box id="list-container" className={classes.root}>
      <FixedSizeList
        height={virtualScrollConfig.height}
        width={virtualScrollConfig.width}
        itemSize={virtualScrollConfig.rowHeight}
        itemCount={data.length}
        className={classes.customListContainer}
      >
        {(virtalScrollProps: IVirtualScrollProps) => {
          return renderListRow(virtalScrollProps);
        }}
      </FixedSizeList>
    </Box>
  );
};

export default CustomList;
